/**
 * Constants used when creating items. The source is set to either BC or Private
 * based on whether we're creating ads for orgs.
 */
export const ITEM_INSERTION_FLOW_SOURCES = {
    PRIVATE: 589,
    BC: 585,
};
